import React from 'react';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import moment from 'moment-timezone';
import CollapsibleItem from 'components/v2/list/CollapsibleItem';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';

export default function ContractSummary({ data, defaultOpen = true }) {
  const { t } = useTranslation();
  if (!data) {
    return null;
  }

  function renderHeading() {
    return (
      <div
        data-testid="quickpay-summary-item"
        className="flex items-start justify-end space-x-3 flex-1 relative"
      >
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 w-full">
          <DescriptionListItem
            dataTestId="quickpay-summary-start-date"
            label={t('START_DATE')}
            className="text-left"
          >
            {moment.tz(data.start_date, DEFAULT_TIMEZONE).format('MM/DD/YYYY')}
          </DescriptionListItem>
          <DescriptionListItem
            dataTestId="quickpay-summary-end-date"
            label={t('END_DATE')}
            className="text-left"
          >
            {moment.tz(data.end_date, DEFAULT_TIMEZONE).format('MM/DD/YYYY')}
          </DescriptionListItem>
          <DescriptionListItem
            dataTestId="quickpay-summary-discount"
            label={t('DISCOUNT')}
            className="text-left"
          >
            {data.terms_and_conditions[0]?.rate?.value}
          </DescriptionListItem>
          <DescriptionListItem
            dataTestId="quickpay-summary-days"
            label={t('DAYS')}
            className="text-left"
          >
            {data.terms_and_conditions[0]?.duration?.value}
          </DescriptionListItem>
          <DescriptionListItem
            dataTestId="quickpay-summary-payment-method"
            label={t('PAYMENT_METHOD')}
            className="text-left"
          >
            {t(sluggify(data.terms_and_conditions[0]?.payment_method))}
          </DescriptionListItem>
          {data?.updated_by && (
            <DescriptionListItem
              dataTestId="quickpay-summary-updated-by"
              label={titleize(t('USER'))}
              className="text-left"
            >
              {data.updated_by}
            </DescriptionListItem>
          )}
        </div>
      </div>
    );
  }

  return (
    <CollapsibleItem className="flex-1" hideIcon defaultOpen={defaultOpen}>
      {renderHeading()}
    </CollapsibleItem>
  );
}
